
import ajax from '../http/ajax'

export const getAggregationSearchList = params => {
    return ajax.get('getAggregationSearchList', params)
}
export const getAggregationInitSearchList = params => {
    return ajax.get('getAggregationInitSearchList', params)
}
